import React from "react";
import styles from "./Dashboard.module.scss";
import Header from "../../components/Header/Header";
import Aside from "../../components/Aside/Aside";
import Main from "./Components/Main/Main";
import FooterClient from "../../components/FooterClient/FooterClient";

const Dashboard = ({ currentLang, setCurrentLang, role }) => {

  return (
    <div className={styles.wrapper}>
      <Aside />
      <div className={styles.container}>
        <Header currentLang={currentLang} setCurrentLang={setCurrentLang} />
        <Main currentLang={currentLang} role={role}/>
        <div className={styles.footer}>
          <FooterClient />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
